import type { SelectOption } from '@bambi/component-library/src/components/inputs/Select/SelectOption/SelectOption';

import { formatPassengerLabel } from './formatPassengerLabel';
import type { PassengerRead } from 'src/common/external/bambi-api/bambiApi';

export function buildPassengerSelectOption(
  passenger: PassengerRead
): SelectOption {
  return {
    label: formatPassengerLabel(passenger),
    value: passenger.id,
  };
}
